var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", { staticClass: "ui-title" }, [_vm._v("Login")]),
      _vm._v(" "),
      _c(
        "ui-form",
        {
          attrs: { "is-processing": _vm.isProcessing, valid: _vm.formValid },
          on: {
            "update:valid": function ($event) {
              _vm.formValid = $event
            },
            submit: _vm.login,
          },
        },
        [
          _c("ui-input", {
            attrs: {
              "fixed-label": "",
              label: "E-mail",
              required: "",
              type: "email",
            },
            model: {
              value: _vm.email,
              callback: function ($$v) {
                _vm.email = $$v
              },
              expression: "email",
            },
          }),
          _vm._v(" "),
          _c("ui-input", {
            attrs: {
              "fixed-label": "",
              label: "Password",
              required: "",
              type: "password",
            },
            model: {
              value: _vm.password,
              callback: function ($$v) {
                _vm.password = $$v
              },
              expression: "password",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "ui-layout ui-alignment-center-space-between",
              staticStyle: { "flex-wrap": "nowrap" },
            },
            [
              _c("router-link", { attrs: { to: { name: "ForgotPassword" } } }, [
                _vm._v("Forgot password?"),
              ]),
              _vm._v(" "),
              _c("ui-button", {
                attrs: {
                  disabled: _vm.isProcessing,
                  primary: "",
                  raised: "",
                  text: "Log in",
                  type: "submit",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.hideRegistration
        ? _c("router-link", { attrs: { to: { name: "Register" } } }, [
            _vm._v("\n\t\tRegister\n\t"),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }